import {select, fork, take, put, takeEvery} from 'redux-saga/effects';
import {fetchRequest} from '@computerrock/formation-core';
import * as adminActionTypes from '../adminActionTypes';


function* handleLogin({payload}) {
    if (!payload) return;
    const {identifier, password} = payload;
    const {serviceManager} = yield select(state => state.application);
    const ftemStrapiService = serviceManager.loadService('ftemStrapiService');
    if (!identifier || !password) {
        yield put({
            type: adminActionTypes.LOGIN_ERROR,
            error: {message: 'Email and password are required'},
        });
        return;
    }


    yield fork(
        fetchRequest,
        adminActionTypes.START_LOGIN_REQUEST,
        ftemStrapiService.sendLogin,
        {...payload},
    );
    const responseAction = yield take([
        adminActionTypes.START_LOGIN_REQUEST_SUCCESS,
        adminActionTypes.START_LOGIN_REQUEST_FAILED,
    ]);
    if (!responseAction.error && responseAction.payload) {
        yield put({
            type: adminActionTypes.STORE_LOGIN_RESPONSE,
            payload: responseAction.payload,
        });
    } else {
        yield put({
            type: `${adminActionTypes.START_LOGIN_REQUEST}_FAILED`,
            error: responseAction.error || {message: `Login failed: ${responseAction.type}`},
        });
    }
}

function* loginSaga() {
    yield takeEvery(adminActionTypes.START_LOGIN_REQUEST, handleLogin);
}


export default loginSaga;
